"use client";

import Gallery from "@/components/srilanka-gallery/SrilankaGallery";

import "./hero.scss";

const Hero = () => {
    return (
        <section className="itinerary-hero-section pt-6 pb-10 md:pb-20">
            <Gallery />
        </section>
    );
};

export default Hero;
